module.exports = __webpack_public_path__ + "img/armholecurve_small.2dd4c54b.png";